import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { Mail, MessageCircle } from "lucide-react";

export const Route = createFileRoute("/contact")({
  head: () => ({
    meta: [
      { title: "Contact Peopels — London Support" },
      { name: "description", content: "Get in touch with Peopels. London-based human support, fast." },
      { property: "og:title", content: "Contact Peopels" },
      { property: "og:description", content: "Get in touch with Peopels — London-based human support." },
      { property: "og:url", content: "/contact" },
    ],
    links: [{ rel: "canonical", href: "/contact" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ContactPage",
          url: "/contact",
          mainEntity: {
            "@type": "Organization",
            name: "Peopels",
            email: "hello@peopels.com",
            areaServed: { "@type": "AdministrativeArea", name: "Greater London" },
            contactPoint: [{ "@type": "ContactPoint", contactType: "customer support", email: "hello@peopels.com", areaServed: "Greater London", availableLanguage: ["English"] }],
          },
        }),
      },
    ],
  }),
  component: Page,
});

function Page() {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      <main id="main-content" className="mx-auto w-full max-w-3xl flex-1 px-4 py-16 sm:px-6 lg:px-8">
        <h1 className="font-display text-4xl font-bold">Contact us</h1>
        <p className="mt-3 text-muted-foreground">We'd love to hear from you. Real humans, London hours.</p>
        <div className="mt-8 grid gap-4 sm:grid-cols-2">
          <a href="mailto:hello@peopels.com" className="flex items-start gap-4 rounded-2xl border border-border bg-card p-6 transition hover:border-primary/30 hover:shadow-card">
            <Mail className="h-5 w-5 text-primary" />
            <div><p className="font-semibold">Email</p><p className="text-sm text-muted-foreground">hello@peopels.com</p></div>
          </a>
          <div className="flex items-start gap-4 rounded-2xl border border-border bg-card p-6">
            <MessageCircle className="h-5 w-5 text-primary" />
            <div><p className="font-semibold">Live chat</p><p className="text-sm text-muted-foreground">Mon-Sat, 9am-7pm</p></div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
